import { getCurrentDomain } from "./getters.mjs";
const saveCookieForCurrentDomain = (cookieName, cookieValue, millisecondsTTL, encode = false) => {
  if (encode) {
    cookieValue = encodeURIComponent(cookieValue);
  }
  const currentDomain = getCurrentDomain();
  const newCookie = `${cookieName}=${cookieValue}; SameSite=Lax; domain=${currentDomain}; path=/`;
  if (millisecondsTTL) {
    let expiredData = /* @__PURE__ */ new Date();
    expiredData.setTime((/* @__PURE__ */ new Date()).getTime() + millisecondsTTL);
    let expires = `; expires=${expiredData.toUTCString()}`;
    window.document.cookie = newCookie + expires;
  } else {
    window.document.cookie = newCookie;
  }
};
const getCookieByName = (name, encode = false) => {
  const match = document.cookie.match(new RegExp(name + "=([^;]+)"));
  let cookieValue;
  if (match) {
    if (encode) {
      cookieValue = decodeURIComponent(match[1]);
    } else {
      cookieValue = match[1];
    }
    return cookieValue;
  }
};
const deleteCookieByName = (cookieName) => {
  const currentDomain = getCurrentDomain();
  document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=${currentDomain};path=/`;
};
const deleteAllCookiesStartingWith = (startsWith) => {
  var cookiesArray = document.cookie.split(";");
  for (var i = 0; i < cookiesArray.length; i++) {
    var cookie = cookiesArray[i].trim();
    var cookieName = cookie.split("=")[0];
    if (cookieName.indexOf(startsWith) === 0) {
      deleteCookieByName(cookieName);
    }
  }
};
const deleteInvalidCookieByName = (cookieName) => {
  document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
};
const setCookieEvent = (event, days) => {
  let expires = "";
  if (days) {
    let date = /* @__PURE__ */ new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1e3);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = "cookieEvent=" + (event || "") + expires + "; path=/";
};
const hasCookieEvent = (event) => {
  return document.cookie.split(";").filter((item) => item.includes(`cookieEvent=${event}`)).length > 0;
};
const getCookie = (cokieName) => {
  if (hasCookieEvent(cokieName)) {
    const cookieValue = document.cookie.split(";").find((row) => row.trim().startsWith(`${cokieName}=`)).split("=")[1];
    return `${cookieValue}`;
  }
  return "";
};
const clearCookieEvent = function() {
  document.cookie = "cookieEvent=;expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
};
export {
  clearCookieEvent,
  deleteAllCookiesStartingWith,
  deleteCookieByName,
  deleteInvalidCookieByName,
  getCookie,
  getCookieByName,
  hasCookieEvent,
  saveCookieForCurrentDomain,
  setCookieEvent
};
//# sourceMappingURL=cookie.mjs.map
